!function (e, a) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = a() : "function" == typeof define && define.amd ? define(a) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.ru = a());
}(this, function () {
  "use strict";

  return [{
    locale: "ru",
    pluralRuleFunction: function (e, a) {
      var t = String(e).split("."),
        r = t[0],
        o = !t[1],
        n = r.slice(-1),
        l = r.slice(-2);
      return a ? "other" : o && 1 == n && 11 != l ? "one" : o && n >= 2 && n <= 4 && (l < 12 || l > 14) ? "few" : o && 0 == n || o && n >= 5 && n <= 9 || o && l >= 11 && l <= 14 ? "many" : "other";
    },
    fields: {
      year: {
        displayName: "год",
        relative: {
          0: "в этом году",
          1: "в следующем году",
          "-1": "в прошлом году"
        },
        relativeTime: {
          future: {
            one: "через {0} год",
            few: "через {0} года",
            many: "через {0} лет",
            other: "через {0} года"
          },
          past: {
            one: "{0} год назад",
            few: "{0} года назад",
            many: "{0} лет назад",
            other: "{0} года назад"
          }
        }
      },
      "year-short": {
        displayName: "г.",
        relative: {
          0: "в этом г.",
          1: "в след. г.",
          "-1": "в прошлом г."
        },
        relativeTime: {
          future: {
            one: "через {0} г.",
            few: "через {0} г.",
            many: "через {0} л.",
            other: "через {0} г."
          },
          past: {
            one: "{0} г. назад",
            few: "{0} г. назад",
            many: "{0} л. назад",
            other: "{0} г. назад"
          }
        }
      },
      month: {
        displayName: "месяц",
        relative: {
          0: "в этом месяце",
          1: "в следующем месяце",
          "-1": "в прошлом месяце"
        },
        relativeTime: {
          future: {
            one: "через {0} месяц",
            few: "через {0} месяца",
            many: "через {0} месяцев",
            other: "через {0} месяца"
          },
          past: {
            one: "{0} месяц назад",
            few: "{0} месяца назад",
            many: "{0} месяцев назад",
            other: "{0} месяца назад"
          }
        }
      },
      "month-short": {
        displayName: "мес.",
        relative: {
          0: "в этом мес.",
          1: "в следующем мес.",
          "-1": "в прошлом мес."
        },
        relativeTime: {
          future: {
            one: "через {0} мес.",
            few: "через {0} мес.",
            many: "через {0} мес.",
            other: "через {0} мес."
          },
          past: {
            one: "{0} мес. назад",
            few: "{0} мес. назад",
            many: "{0} мес. назад",
            other: "{0} мес. назад"
          }
        }
      },
      day: {
        displayName: "день",
        relative: {
          0: "сегодня",
          1: "завтра",
          2: "послезавтра",
          "-2": "позавчера",
          "-1": "вчера"
        },
        relativeTime: {
          future: {
            one: "через {0} день",
            few: "через {0} дня",
            many: "через {0} дней",
            other: "через {0} дня"
          },
          past: {
            one: "{0} день назад",
            few: "{0} дня назад",
            many: "{0} дней назад",
            other: "{0} дня назад"
          }
        }
      },
      "day-short": {
        displayName: "дн.",
        relative: {
          0: "сегодня",
          1: "завтра",
          2: "послезавтра",
          "-2": "позавчера",
          "-1": "вчера"
        },
        relativeTime: {
          future: {
            one: "через {0} дн.",
            few: "через {0} дн.",
            many: "через {0} дн.",
            other: "через {0} дн."
          },
          past: {
            one: "{0} дн. назад",
            few: "{0} дн. назад",
            many: "{0} дн. назад",
            other: "{0} дн. назад"
          }
        }
      },
      hour: {
        displayName: "час",
        relative: {
          0: "в этот час"
        },
        relativeTime: {
          future: {
            one: "через {0} час",
            few: "через {0} часа",
            many: "через {0} часов",
            other: "через {0} часа"
          },
          past: {
            one: "{0} час назад",
            few: "{0} часа назад",
            many: "{0} часов назад",
            other: "{0} часа назад"
          }
        }
      },
      "hour-short": {
        displayName: "ч",
        relative: {
          0: "в этот час"
        },
        relativeTime: {
          future: {
            one: "через {0} ч.",
            few: "через {0} ч.",
            many: "через {0} ч.",
            other: "через {0} ч."
          },
          past: {
            one: "{0} ч. назад",
            few: "{0} ч. назад",
            many: "{0} ч. назад",
            other: "{0} ч. назад"
          }
        }
      },
      minute: {
        displayName: "минута",
        relative: {
          0: "в эту минуту"
        },
        relativeTime: {
          future: {
            one: "через {0} минуту",
            few: "через {0} минуты",
            many: "через {0} минут",
            other: "через {0} минуты"
          },
          past: {
            one: "{0} минуту назад",
            few: "{0} минуты назад",
            many: "{0} минут назад",
            other: "{0} минуты назад"
          }
        }
      },
      "minute-short": {
        displayName: "мин.",
        relative: {
          0: "в эту минуту"
        },
        relativeTime: {
          future: {
            one: "через {0} мин.",
            few: "через {0} мин.",
            many: "через {0} мин.",
            other: "через {0} мин."
          },
          past: {
            one: "{0} мин. назад",
            few: "{0} мин. назад",
            many: "{0} мин. назад",
            other: "{0} мин. назад"
          }
        }
      },
      second: {
        displayName: "секунда",
        relative: {
          0: "сейчас"
        },
        relativeTime: {
          future: {
            one: "через {0} секунду",
            few: "через {0} секунды",
            many: "через {0} секунд",
            other: "через {0} секунды"
          },
          past: {
            one: "{0} секунду назад",
            few: "{0} секунды назад",
            many: "{0} секунд назад",
            other: "{0} секунды назад"
          }
        }
      },
      "second-short": {
        displayName: "сек.",
        relative: {
          0: "сейчас"
        },
        relativeTime: {
          future: {
            one: "через {0} сек.",
            few: "через {0} сек.",
            many: "через {0} сек.",
            other: "через {0} сек."
          },
          past: {
            one: "{0} сек. назад",
            few: "{0} сек. назад",
            many: "{0} сек. назад",
            other: "{0} сек. назад"
          }
        }
      }
    }
  }, {
    locale: "ru-BY",
    parentLocale: "ru"
  }, {
    locale: "ru-KG",
    parentLocale: "ru"
  }, {
    locale: "ru-KZ",
    parentLocale: "ru"
  }, {
    locale: "ru-MD",
    parentLocale: "ru"
  }, {
    locale: "ru-UA",
    parentLocale: "ru"
  }];
});